var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-wrapper"},[_c('div',{staticClass:"user-wrapper__header"},[_c('BackArrowComp',{attrs:{"goTo":'/users',"text":_vm.userObjectToModify.name}})],1),_c('div',{staticClass:"user-wrapper__content"},[_c('ProfileForm')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }